import { useEffect, useRef } from "react";

// Custom Hook to detect outside click
const useOutsideClick = (callback:any) => {
  const ref:any = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event:any) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback(); // Close dropdown or trigger any action on outside click
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [callback]);

  return ref;
};

export default useOutsideClick;
